import React, { useContext } from 'react';
import './index.scss';
// import getSiteConfig from '../../../siteConfig.js';
import { RootContext } from '@/container';
// const siteConfig = getSiteConfig(process.env.SITE_ID);
var Android = function (props) {
    var _a = useContext(RootContext), state = _a.state, dispatch = _a.dispatch;
    return (React.createElement("div", { className: "mod-android", style: {
            height: state.viewHeight
        } },
        React.createElement("div", null,
            React.createElement("img", { src: require("../../assets/img/ios/" + process.env.SITE_ID + ".png") }))));
};
export default Android;
